export const AUTHENTICATED = 'AUTHENTICATED';
export const AUTH_TOKEN = 'auth_token';
export const SIGNOUT_SUCCESS = 'SIGNOUT_SUCCESS';
